export default __webpack_public_path__ + "static/media/03-VEH-(4-2).162f75ac.jpg";